import { css } from '@emotion/css';

export const pictureContainerCss = css`
  display: inline-block; /* Ensure container always covers image so that stickers align correctly */
  position: relative;
  vertical-align: top; /* Ensure no additional space is added below image due to 'display: inline-block' */
`;
